import { Card, CardBody, Flex, TooltipText, useTooltip } from 'uikit'
import { useTranslation } from 'react-i18next'
import { NodeRound, BetPosition } from 'state/types'
// import useTheme from 'hooks/useTheme'
import { RoundResultBox } from '../RoundResult'
import MultiplierArrow from './MultiplierArrow'
import { Image } from 'components'
import CardHeader from './CardHeader'
import RoundProgress from 'components/RoundProgress'

interface CalculatingCardProps {
  round: NodeRound | any
  hasEnteredUp: boolean
  hasEnteredDown: boolean
}

const CalculatingCard: React.FC<CalculatingCardProps> = ({ round, hasEnteredUp, hasEnteredDown }) => {
  const { t } = useTranslation()
  // const { theme } = useTheme()
  const { targetRef, tooltip, tooltipVisible } = useTooltip(t('PREDICTION_66'), { placement: 'bottom' })

  return (
    <>
      <Card>
        <CardHeader
          status="calculating"
          icon={<Image src={require('assets/images/prediction/live.svg').default} width="24px" />}
          title={t('PREDICTION_59')}
          epoch={round.epoch}
        />
        <RoundProgress scale="sm" lockTimestamp={1} closeTimestamp={1} />

        <CardBody p="16px">
          <MultiplierArrow isDisabled hasEntered={hasEnteredUp} />
          <RoundResultBox>
            <Flex alignItems="center" justifyContent="center" flexDirection="column">
              <Image src="/images/mojito-games-loading-trans.webp" style={{ width: '61px' }} />
              <Flex ref={targetRef} mt="12px">
                <TooltipText fontSize="14px" color="textRemark" bold>
                  {t('PREDICTION_67')}
                </TooltipText>
              </Flex>
            </Flex>
          </RoundResultBox>
          <MultiplierArrow betPosition={BetPosition.BEAR} isDisabled hasEntered={hasEnteredDown} />
        </CardBody>
      </Card>
      {tooltipVisible && tooltip}
    </>
  )
}

export default CalculatingCard
